import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms'; // ✅ needed for [(ngModel)]
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { environment } from '../../../../../environments/environment';
import { SubmittedSuccessComponentComponent } from '../../../../components/Assignments/submitted-success-component/submitted-success-component.component';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-assignmentsubjects',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    SubmittedSuccessComponentComponent,
    TranslateDirective
  ],
  templateUrl: './assignmentsubjects.component.html',
  styleUrls: ['./assignmentsubjects.component.scss'],
})
export class AssignmentsubjectsComponent implements OnInit {
  // JSON data for all assignments and their questions
  assignmentData = [
    {
      assignmentId: 1,
      subject: 'Mathematics',
      assignmentTitle:
        'Calculus Integration Assignment Calculus Integration Assignment Calculus Integration Assignment Calculus Integration Assignment',
      class: '10th Grade',
      questions: [
        {
          questionId: 1,
          questionText: 'What is the derivative of f(x) = 2x^3 - 5x + 1?',
          correctAnswer: 0,
          file: {
            name: 'a-zebooks.pdf',
            url: 'https://nludelhi.ac.in/download/library/a-zebooks.pdf',
          },
        },
        {
          questionId: 2,
          questionText: 'Solve for x in the equation 2x + 5 = 11.',
          correctAnswer: 1,
        },
        {
          questionId: 3,
          questionText: 'What is the integral of f(x) = x^2?',
          correctAnswer: 0,
        },
        {
          questionId: 4,
          questionText: 'Find the value of sin(90°).',
          correctAnswer: 1,
        },
        {
          questionId: 5,
          questionText: 'Simplify the expression (a+b)^2.',
          correctAnswer: 1,
        },
        {
          questionId: 6,
          questionText: 'What is the value of π to two decimal places?',
          correctAnswer: 0,
        },
        {
          questionId: 7,
          questionText: 'What is the formula for the area of a circle?',
          correctAnswer: 2,
        },
        {
          questionId: 8,
          questionText: 'Which number is prime?',
          correctAnswer: 2,
        },
        {
          questionId: 9,
          questionText: 'Solve for y in the equation 3y - 2 = 10.',
          correctAnswer: 0,
        },
        {
          questionId: 10,
          questionText: 'What is the result of 5! (five factorial)?',
          correctAnswer: 2,
        },
      ],
    },
    {
      assignmentId: 2,
      subject: 'Science',
      assignmentTitle: 'Biology Cell Structure Assignment',
      class: '10th Grade',
      questions: [
        {
          questionId: 1,
          questionText: 'What is the chemical symbol for water?',
          correctAnswer: 0,
        },
        {
          questionId: 2,
          questionText: 'What is the powerhouse of the cell?',
          correctAnswer: 1,
        },
      ],
    },
    {
      assignmentId: 3,
      subject: 'History',
      assignmentTitle: 'American Revolution Assignment',
      class: '10th Grade',
      questions: [
        {
          questionId: 1,
          questionText: 'Who was the first President of the United States?',
          correctAnswer: 1,
        },
      ],
    },
  ];

  assignment: any;
  isSubmitted = false;
  showDetails = false;
  isDisabled = false;
  imageUrl =
    environment.ASSET_URL +
    environment.ASSET_CONTAINER +
    '/' +
    'ERP/assets/common/Success.gif';

  constructor(private route: ActivatedRoute, private _router: Router) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const assignmentId = +params['subjectsId'];
      this.assignment = this.assignmentData.find(
        (a) => a.assignmentId === assignmentId
      );

      // ✅ initialize answer + file fields for each question
      if (this.assignment) {
        this.assignment.questions.forEach((q: any) => {
          q.answer = ''; // text answer
          q.file = null; // uploaded file
        });
      }
    });
  }
  submitAssignment(): void {
    if (this.assignment) {
      const answers = this.assignment.questions.map((q: any) => ({
        questionId: q.questionId,
        answer: q.answer || '',
        file: q.file || null,
      }));
      // Here you can save 'answers' to server or local storage if needed
      console.log('Submitted Answers:', answers);

      // Show confirmation message
      this.isSubmitted = true;
      this.showDetails = false;
    }
  }
  viewSubmissionDetails(): void {
    this.showDetails = true;
    this.isDisabled = true;
  }
  getOptionLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }
  trackByIndex(index: number, item: any): number {
    return index;
  }

  onFileSelect(event: Event, questionIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.assignment.questions[questionIndex].file = file;
      console.log('File uploaded for Question', questionIndex + 1, file);
    }
  }
  goBack(): void {
    this._router.navigate(['/assignments']);
  }
}
